module.exports = __webpack_public_path__ + "icomoon.ddd818f6c1d4cc8bcdf8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.ttf?mkks98
// module id = ./src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.ttf?mkks98
// module chunks = styles